import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from "@angular/core";
import { Subject, Observable, Subscription } from "rxjs";
import { ioService } from "../../service/io.service";
import { eventEmitterService } from "../../service/eventEmitter.service";
import { GroupService } from "../../service/group.service";
import { UserInfoService } from "../../service/user-info.service";
import { environment } from "../../../environments/environment";
import { isNullOrUndefined } from "util";
import { PostFilterService } from "../../service/post-filter.service";
import { ActivatedRoute, Router } from "@angular/router";
import { uniqBy, remove, differenceBy, difference, filter } from "lodash";
declare var $: any;
@Component({
  selector: "app-message",
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.css"],
})
export class MessageComponent implements OnInit, AfterViewInit {
  //Declared all variables
  apiUrl = environment.apiUrl;
  s3apiUrl = environment.s3BucketApi;
  onlineNewMsgUsers = [];
  allOnlineUsers = [];
  title = "Message Application";
  message = "";
  messages = [];
  newMessageNoResult = false;
  onlineUsers = [];
  onlineUsersLists = [];
  buildingsFilterUsersLists = [];
  buildingsFilterUsers = [];
  activeUser;
  userId;
  toUsers;
  noResult = false;
  touser = { firstName: "", lastName: "", address: "" };
  socketId;
  group = { name: "", description: "" };
  messageToSend: string;
  showNewMsg = false;
  totalMsg = 0;
  tempOnlineUsers;
  private timer;
  private sub: Subscription;
  connectedRooms = [];
  connectedRoomsWithUsers = [];
  newMessageUserList = [];
  createNewPrivateGroupButton = true;
  newPrivateGroupMembers = [];

  stock;
  caption;
  files = [];
  selectedFileType;
  roomId;
  toUserId;
  imageSrc = [];
  error;
  dateUpdater = "?ver=" + Date.now();
  set_clearTimeInterval;
  isLoading = false;
  isButtonEnabled = false;
  uploadButtonToShow: boolean = true;
  user: any;
  private totalCount = {
    getAllMsgCount: 0,
    getAllGroupMsgCount: 0,
    getAllGroupsCount: 0,
  };

  @ViewChild("parentRef", { static: false })
  public parentRef: ElementRef;

  // Invoke all services files when this file intial load
  constructor(
    private _ioService: ioService,
    private chatService: eventEmitterService,
    private _groupService: GroupService,
    private _changeDetector: ChangeDetectorRef,
    private link: PostFilterService,
    private userInfo: UserInfoService,
    private route: ActivatedRoute
  ) {}

  //Get a reference element by using ViewChild
  @ViewChild("chatRoom", { static: false }) private chat_window: ElementRef;

  @ViewChild("newMsgUserSearch", { static: false })
  private newMsgUserSearch: ElementRef;

  ngOnInit() {
    /*
     * Changed version to all images with present time for images render issue
     * Every one second it will change the version , After 8 second the interval will be cleared.
     */
    // this.link.currentMessage4.subscribe((res)=>{
    //     this.dateUpdater = '?ver='+Date.now();
    //     this.isLoading = false;
    //    setTimeout(() => {
    //     this.dateUpdater = '?ver='+Date.now();
    //    }, 500);
    //    setTimeout(() => {
    //     this.dateUpdater = '?ver='+Date.now();
    //    }, 1000);
    // })
    this.userInfo.user.subscribe((data: any) => {
      this.user = data;
    });
    var queryParams = this.route.snapshot.queryParams;
    if (queryParams.user != undefined && queryParams.user) {
      var chatuser = {
        id: queryParams.user,
        chatType: "user",
        page: "messages",
        firstName: queryParams.fname,
        lastName: queryParams.lname,
      };
      this.joinPrivate(chatuser);
    }

    // Listening a event for open new message section in messages page
    this.chatService.eventEmit$.subscribe((chatUser) => {
      //If user click New Message button from Message header component,
      //Here listening that evet to show new message user search section
      if (chatUser.newMsg) {
        this.showNewMessage();
      }
      //Listening building filter values from message header component event emition
      if (chatUser.filterBuilding) {
        this.resetFilterBuilding(chatUser.filterBuilding);
      }
    });

    this.chatService._msgCount$.subscribe((event) => {
      this.totalCount.getAllGroupMsgCount = event["getAllGroupMsgCount"];
      this.totalCount.getAllGroupsCount = event["getAllGroupsCount"];
    });

    //Subscribed all sockets emition groups results based on current logged in user's
    this.populateUsers();
    this.populateGroups();
    this.allOnlineUsers = this.onlineUsers;
  }

  populateUsers() {
    this._ioService.ioMessage$.subscribe((message) => {
      // console.log("ioService Message", message);
      /*
       *  Get all residents based on current logged in user's
       */
      if (message["users"]) {
        // console.log("ioService Message[users]", message);
        var toUserId = message["users"].id;
        message["users"].chatType = "user";
        // Push group to the user list for it to iterate to in the sidebar
          this.pushToUserListAndUpdateCounts(message["users"]);
        // assign building filter users and sort them on the basis of their chat messages
        this.assignBuildingFilterUsersAndSort();
        // update message window counter
        if (message["getAllMsgCount"]) {
          this.updateMessageCount(message["getAllMsgCount"]);
        }
      }
      //Get the socket connection information
      if (message["session"]) {
        this.updateSocketConnection(message["session"]);
      }

      //Get all messages and newly created messages
      if (message["message"]) {
        this.chatMessageListener(message);
      } else if (message["message"] == "") {
        this.messages = [];
      }
      if (!this._changeDetector["destroyed"]) {
        this._changeDetector.detectChanges();
      }
    });
  }

  populateGroups() {
    this._groupService.group$.subscribe((message) => {
      /*
       *  Get all groups based on current logged in user's
       */
      // Handle both "groups" and "createdGroup" / "allresidentsgroups" for newly created groups
      let groupData = message["groups"] || message["createdGroup"] || message["allresidentsgroups"];

      if (groupData) {
          var groupId = groupData.id;
          groupData.chatType = "group";
          // Push group to the user list for it to iterate to in the sidebar
          this.pushToUserListAndUpdateCounts(groupData);
          // assign building filter users and sort them on the basis of their chat messages
          this.assignBuildingFilterUsersAndSort();
          // update message window counter
          if (message["getAllPrivateGroupMsgCount"]) {
            this.updateMessageCount(message["getAllPrivateGroupMsgCount"]);
          }

          // Check if this is a newly created private group we're waiting for
          if (!!this.newPrivateGroupMembers.length && groupData.private === true) {
            if (difference(groupData.members, this.newPrivateGroupMembers).length == 0) {
              // Auto-join the newly created group
              this.newPrivateGroupMembers = []; // reset it back
              this.newMessageUserList = [];
              this.showNewMsg = false;
              $(".textarea_wrap").removeClass("positionCustom");
              // Need to wait for messages to be loaded, so trigger joinPrivate
              setTimeout(() => {
                this.joinPrivate(groupData);
              }, 500);
            }
          }
      }
      // Get the socket connection information
      if (message["session"]) {
        this.updateSocketConnection(message["session"]);
      }
      // Get all group messages and newly created group message
      if (message["message"]) {
        this.chatMessageListener(message); // that'll work!
        // After room is added to messages array, check if we need to auto-join for newly created groups
        if (!!this.newPrivateGroupMembers.length && message["page"] == "messages") {
          for (var i = 0; i < this.onlineUsers.length; ++i) {
            if (!!this.onlineUsers[i].name) {
              if (
                difference(this.onlineUsers[i].members, this.newPrivateGroupMembers)
                  .length == 0
              ) {
                this.newPrivateGroupMembers = []; // reset it back
                this.newMessageUserList = [];
                this.showNewMsg = false;
                $(".textarea_wrap").removeClass("positionCustom");
                this.joinPrivate(this.onlineUsers[i]);
                break;
              }
            }
          }
        }
      } else if (message["message"] == "") {
        this.messages = [];
      }
      if (!this._changeDetector["destroyed"]) {
        this._changeDetector.detectChanges();
      }
    });
  }

  pushToUserListAndUpdateCounts(obj) {
    // obj, here can be a group or a user
    // Messages tab should only show users and private groups
    if (obj.chatType === "group" && obj.private !== true) {
      return false; // don't show public groups in Messages tab
    }
    if (this.onlineUsersLists.indexOf(obj.id) > -1) {
      for (let user of this.onlineUsers) {
        if (user.id == obj.id) {
          user.totalUnReadMsg = obj.totalUnReadMsg;
          user.lastMessage = obj.lastMessage;
          if (obj.chatType == "group") {
            user.lastMessageCreatedDate = obj.lastMessageCreatedDate
              ? obj.lastMessageCreatedDate
              : obj.createdAt;
          } else {
            user.lastMessageCreatedDate = obj.lastMessageCreatedDate;
          }
        }
      }
      if (obj.buildingsFilter === true) {
        this.buildingsFilterUsersLists.push(obj.id);
        this.buildingsFilterUsers.push(obj);
        this.buildingsFilterUsersLists = this.buildingsFilterUsersLists.filter(
          (v, i, a) => a.indexOf(v) === i
        );
        this.buildingsFilterUsers = this.buildingsFilterUsers.filter(
          (v, i, a) => a.indexOf(v) === i
        );
      }
    } else {
      this.onlineUsersLists.push(obj.id);
      this.onlineUsers.push(obj);
    }
    // console.log("OnlineUsers", this.onlineUsers, this.onlineUsersLists);
  }

  assignBuildingFilterUsersAndSort() {
    if (this.buildingsFilterUsersLists.length > 0) {
      this.onlineUsers = this.buildingsFilterUsers;
    }
    this.onlineUsers.sort((a, b) => {
      var currentLMCD = isNaN(Date.parse(a.lastMessageCreatedDate))
        ? 0
        : Date.parse(a.lastMessageCreatedDate);
      var nextLMCD = isNaN(Date.parse(b.lastMessageCreatedDate))
        ? 0
        : Date.parse(b.lastMessageCreatedDate);
      if (currentLMCD > nextLMCD) {
        return -1;
      }
      if (currentLMCD < nextLMCD) {
        return 1;
      }
    });
  }

  updateMessageCount(count) {
    // still on object, but looks for "getAllMsgCount"
    this.totalCount.getAllMsgCount = count;
    this.chatService._msgCount$.next(this.totalCount);
  }

  updateSocketConnection(obj) {
    this.socketId = obj["socketId"];
    this.userId = obj["user"]["id"];
    this.activeUser = obj["user"];
  }

  chatMessageListener(message) {
    let messageContent = "";
    // ;
    if (message["message"] && message["allMessages"]) {
      // Handle group messages
      // console.log("ChatMessageListener", message);
      if (message["page"] == "messages") {
        // only listen to private groups
        //Get Room Id
        if (
          message.hasOwnProperty("group") &&
          message["group"].private == true
        ) {
          var groupId = message["groupId"];
          var group = message["group"];

          //When other user's chat window open, initially pushed all groups messages informations
          if (this.connectedRooms.indexOf(groupId) == -1) {
            this.connectedRooms.push(groupId);
            this.connectedRoomsWithUsers.push({
              roomId: groupId,
              group: group,
            });
            this.messages.push({
              roomId: groupId,
              group: group,
              messages: message["message"],
            });
          }
        } else {
          var roomId = message["roomId"];
          var toUser = message["toUser"];
          //When other user's chat window open, initially pushed all messages informations
          if (this.connectedRooms.indexOf(roomId) == -1) {
            this.connectedRooms.push(roomId);
            this.connectedRoomsWithUsers.push({
              roomId: roomId,
              toUser: toUser,
            });
            this.messages.push({
              roomId: roomId,
              toUser: toUser,
              chatType: 'user',
              messages: message["message"],
            });
          }
        }
      }
      // console.log("Final connectedRoomsWithUsers", this.connectedRoomsWithUsers);
    } else {
      // console.log("New Message Listener", message);
      // Listening newly created a group message
      messageContent = message["message"];
      var roomId = null;
      if (message.hasOwnProperty("groupId")) {
        roomId = message.groupId;
      } else if (message.hasOwnProperty("roomId")) {
        roomId = message.roomId;
      }
      // console.log("Detected RoomId", roomId);
      // console.log("Messages", this.messages);
      if (
        (message["page"] == "groups" || message["page"] == "messages") &&
        roomId != null
      ) {
        // Pushed newly created message based on group id
        this.messages.forEach(function callback(currentValue, index, array) {
          if (currentValue.roomId == roomId) {
            const messageExists = currentValue.messages.findIndex(msg => msg.id === message["message"].id) > -1;
            if (!messageExists) {
              currentValue.messages.push(message["message"]);
            }
          }
          currentValue.messages = currentValue.messages.filter(
            (v, i, a) => a.indexOf(v) === i
          );
        });

        //Update read status to this new group message
        var ele = $("#room-" + roomId).find(".main_msg_inner");
        var MsgWindowHeight = ele.find(".row").height();
        if (ele.is(":visible") === true) {
          this.updateMsgStatus(roomId);
          setTimeout(() => {
            $(".Firefox .Rooms").scrollTop(99999);
          }, 300);
        }
        if (
          message["page"] == "groups" ||
          (message["page"] == "messages" && roomId != null)
        ) {
          if (message["message"].paths != undefined) {
            this.isLoading = false;
          }
        }
      }
    }
  }

  createNewPrivateGroup() {
    this.userInfo.getUserInfo();
    // console.log("User Data", this.user);
    let formData = new FormData();
    let memberList = this.newMessageUserList.map((user) => user.id);
    // Add the current user to memberList
    memberList.push(this.user.id);
    // console.log("MemberList", memberList);
    // console.log('onlineUsers', this.onlineUsers);
    let create = true;
    for (let i = 0; i < this.onlineUsers.length; i++) {
      if (!!this.onlineUsers[i].name) {
        if (this.onlineUsers[i].members.length > memberList.length) {
          if (difference(this.onlineUsers[i].members, memberList).length == 0) {
            // console.log('Selected chat', this.onlineUsers[i]);
            create = false;
            this.newMessageUserList = []; // fixes the problems with already created group
            this.showNewMsg = false;
            $(".textarea_wrap").removeClass("positionCustom");
            this.joinPrivate(this.onlineUsers[i]);
            break;
          }
        } else {
          if (difference(memberList, this.onlineUsers[i].members).length == 0) {
            // console.log('Selected chat', this.onlineUsers[i]);
            create = false;
            this.newMessageUserList = []; // fixes the problems with already created group
            this.showNewMsg = false;
            $(".textarea_wrap").removeClass("positionCustom");
            this.joinPrivate(this.onlineUsers[i]);
            break;
          }
        }
      }
    }
    if (create) {
      this.newPrivateGroupMembers = memberList;
      formData.append(
        "formValue",
        JSON.stringify({
          groupName: this.newMessageUserList
            .map((user) => {
              return user.firstName + " " + user.lastName;
            })
            .join(", "),
          members: memberList,
          buildingSelect: [],
          description: "",
          shareToFeed: false,
          socketId: this.socketId,
          file: false,
          private: true,
        })
      );
      this.createNewPrivateGroupButton = false;
      this._groupService.createGroup(formData).subscribe((response) => {
        if (response.success) {
          // console.log("Group Created", response);
          this.newMessageUserList = [];
          this.chatService.triggerSocketService("groupMsg");
        }
        this.createNewPrivateGroupButton = true;
      });
    }
  }
  /*
   * Update read status to all unread messages based on room id
   */
  updateMsgStatus(roomId) {
    this._ioService.updateMsgStatus(roomId);
  }

  resetFilterBuilding(filterBuilding) {
    this.buildingsFilterUsersLists = [];
    this.buildingsFilterUsers = [];

    this.onlineUsersLists = this.onlineUsersLists.filter(
      (user) => user.chatType === "group"
    );
    this.onlineUsers = this.onlineUsers.filter(
      (user) => user.chatType === "group"
    );

    this.populateGroups();
    this.populateUsers();
  }
  /*
   * Set the boolean value for display new message on chat window
   */
  showNewMessage() {
    this.showNewMsg = true;
    this.onlineNewMsgUsers = [];
    $(".textarea_wrap").addClass("positionCustom");
  }

  /*
   * Send a message from chat window
   * roomId, toUserId, textarea - passing params
   */
  sendMessage(room, textarea, e): void {
    // Previously: room.roomId, room.toUser.id, msgToSend , $event
    // Check a empty value of current window textarea element
    let messageObject = {};
    if ($.trim($(textarea).val())) {
      if (room.hasOwnProperty("toUser")) {
        messageObject = {
          message: {
            to: room.toUser.id,
            roomId: room.roomId,
            content: $.trim(textarea.value),
            page: "messages",
          },
        };
        this._ioService.sendChatMessage(messageObject);
      }
      if (room.hasOwnProperty("group")) {
        messageObject = {
          message: {
            groupId: room.roomId,
            content: $.trim(textarea.value),
            page: "groups",
          },
        };
        this._groupService.sendGroupMessage(messageObject);
      }
    }

    $(textarea).val(""); // empty out the message after sending
    e.preventDefault();
    setTimeout(() => {
      $(".Firefox .Rooms").scrollTop(99999);
    }, 300);
  }
  /*
   * Make a private chat room for two connected users
   * to user object - passing params
   */
  joinPrivate(user: any): void {
    this.newMessageNoResult = false;
    if (user.chatType == "group") {
      // Private groups in Messages tab should use 'messages' page
      user.page = user.private === true ? "messages" : "groups";
    } else {
      user.page = "messages"; // Users use 'messages' page
    }
    this.roomId = user.id; 
    //Open room if already exists in dom
    this.connectedRoomsWithUsers.forEach(function callback(
      roomsWithUsers,
      index,
      array
    ) {
      // console.log("roomsWithUsers", roomsWithUsers);
      $("#room-" + roomsWithUsers.roomId).removeClass("activeRoom");
      $("#room-" + roomsWithUsers.roomId).hide();
      $(".Rooms").removeClass("msgContent");
      var roomId;
      if (roomsWithUsers.hasOwnProperty("toUser")) {
        if (roomsWithUsers.toUser.id == user.id) {
          roomId = roomsWithUsers.roomId;
          $("#room-" + roomId).addClass("activeRoom");
          $("#room-" + roomId).addClass("current");
          $("#room-" + roomId).show();
        }
      }
      if (roomsWithUsers.hasOwnProperty("group")) {
        if (roomsWithUsers.group.id == user.id) {
          roomId = roomsWithUsers.roomId;
          $("#room-" + roomId).addClass("activeRoom");
          $("#room-" + roomId).addClass("current");
          $("#room-" + roomId).show();
        }
      }
    });
    this.showNewMsg = false;
    $(".textarea_wrap").removeClass("positionCustom");
    //this.messages = [];
    this.toUsers = user.id;
    this.touser = user;
    //Call a service function to connect other resident's via socket
    if (user.chatType == "user") {
      this._ioService.joinPrivate(user);
    } else if (user.chatType == "group") {
      this._groupService.joinPrivate(user);
    }
    var length = (this.connectedRoomsWithUsers.length + 2) * 400;
    if ($(window).width() < length) {
      length = $(window).width();
    }
    $(".pop_up_wrap").css("width", length + "px");

    var max_length = $(window).width() - 320;

    if (user.chatType == "group") {
      setTimeout(() => {
        $(".Firefox .Rooms").scrollTop(99999);
        $("#room-" + user.id)
          .find("textarea")
          .focus();
        $("html, body").animate(
          {
            scrollTop: $("#room-" + user.id).position().top,
          },
          500
        );
      }, 1000);

      setTimeout(() => {
        this.chatService.triggerSocketService("groupMsg");
        var i = 0;
        var timer = setInterval(() => {
          this.chatService.triggerSocketService("groupMsg");
          i++;
          if (i === 2) {
            clearInterval(timer);
          }
        }, 500);
      }, 500);
    }
    if (user.chatType == "user") {
      setTimeout(() => {
        $(".Firefox .Rooms").scrollTop(99999);
        $("textarea:visible").focus();
        $("html, body").animate(
          {
            scrollTop: $("textarea:visible").position().top,
          },
          1000
        );
        this.chatService.triggerSocketService("message");
      }, 1000);
    }

    $(".msgList").removeClass("current");
    setTimeout(() => {
      $(".msgContent").addClass("current");
    }, 500);
    $("#messages_header").addClass("current");
  }

  appendToUserList(user: any): void {
    if (!this.newMessageUserList) {
      // fail-safe
      this.newMessageUserList = [];
    }
    this.newMessageUserList.push(user); // add user to the list
    this.newMessageUserList = uniqBy(this.newMessageUserList, "id"); // make sure a user isn't added twice!
    this.newMsgUserSearch.nativeElement.value = ""; // reset search input value
    this.onlineNewMsgUsers = []; // reset the dropdown search
  }

  removeFromUserList(user: any): void {
    remove(this.newMessageUserList, (newMessageUser) => {
      // remove user from the list of selected users
      return newMessageUser.id == user.id;
    });
  }

  /*
   * Filtered users list based on user search
   */
  searchUser(searchUser) {
    this.onlineUsers = this.chatService.filterUser(
      this.allOnlineUsers,
      "firstName",
      searchUser
    );
    if (this.onlineUsers.length > 0) {
      this.noResult = false;
    } else {
      this.noResult = true;
    }
  }

  searchNewMsgUser(searchUser) {
    if (!searchUser) {
      this.onlineNewMsgUsers = [];
    } else {
      this.onlineNewMsgUsers = differenceBy(
        this.chatService.filterUser(
          filter(this.allOnlineUsers, (user) => {
            return user.chatType == "user";
          }),
          "firstName",
          searchUser
        ),
        this.newMessageUserList
      );
      if (this.onlineNewMsgUsers.length <= 0) {
        this.newMessageNoResult = true;
      } else {
        this.newMessageNoResult = false;
      }
    }
  }

  joinGroup(): void {
    //submit a change to the observable through the service
    this._ioService.joinGroup();
  }

  leaveGroup(): void {
    this._ioService.leaveGroup();
  }

  ngAfterViewInit() {
    let timer = setInterval(() => {
      this._ioService.registerSailsListener();
      this._groupService.getPrivateGroupsAndCounts();
      if (this.onlineUsers.length > 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  onChange(event, room) {
    this.uploadButtonToShow = true;
    var src = [];
    this.files = [];
    this.imageSrc = [];
    this.isButtonEnabled = false;

    var e = window.event || event;
    var target = e.target || e.srcElement;

    if (target.files.length > 0) {
      var Extension = target.files[0].name
        .substring(target.files[0].name.lastIndexOf(".") + 1)
        .toLowerCase();
      var fileType = "";
      if (
        Extension == "gif" ||
        Extension == "png" ||
        Extension == "bmp" ||
        Extension == "jpeg" ||
        Extension == "jpg"
      ) {
        fileType = "image";
      } else {
        fileType = "document";
      }
      target.files[0].extension = Extension;
      target.files[0].fileType = fileType;
      var fileSize = target.files[0].size / 1024 / 1024;

      const roomId = room.roomId;
      const chatType = room.chatType;
      const toUserId = chatType === 'user' ? room.toUser.id : (room.group ? room.group.id : null);
      if (this.selectedFileType == "image") {
        if (fileType == "image") {
          if (fileSize <= 20) {
            this.error = null;
            this.imageSrc = src;
            for (var i = 0; i < target.files.length; i++) {
              setupReader(target.files[i]);
              this.files.push(target.files[i]);
            }
            this.roomId = roomId;
            this.toUserId = chatType == 'user' ? toUserId : null;
          } else {
            this.files = [];
            this.uploadButtonToShow = false;
            this.error = "File size must not be more than 20 MB";
          }
          $("#messageFileModal").modal("show");
        } else {
          this.files = [];
          this.uploadButtonToShow = false;
          this.error = "Please select either a .jpeg, .jpg, or .png file";
          $("#messageFileModal").modal("show");
        }
      } else if (this.selectedFileType == "document") {
        if (fileType == "document" && Extension == "pdf") {
          if (fileSize <= 20) {
            this.error = null;
            this.imageSrc = ["../../../../assets/images/pdf.svg"];
            for (var i = 0; i < target.files.length; i++) {
              setupReader(target.files[i]);
              this.files.push(target.files[i]);
            }
            this.roomId = roomId;
            this.toUserId = chatType == 'user' ? toUserId : null;
          } else {
            this.files = [];
            this.uploadButtonToShow = false;
            this.error = "File size must not be more than 20 MB";
          }
          $("#messageFileModal").modal("show");
        } else {
          this.files = [];
          this.uploadButtonToShow = false;
          this.error = "Please select .pdf file format";
          $("#messageFileModal").modal("show");
        }
      }
    }
    function setupReader(file) {
      var name = file.name;
      var reader = new FileReader();
      reader.onload = function (e) {
        // get file content
        src.push(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }

  uploadDocuments() {
    this.isButtonEnabled = true;
    
    const submission: any = {
      message: {
        caption: this.caption,
        page: "messages",
      },
      file: this.files && this.files.length > 0 ? this.files[0] : null
    };

    if (!submission.file) {
      this.error = 'No file selected';
      this.isLoading = false;
      this.isButtonEnabled = false;
      return;
    }

    this.isLoading = true;
    if (this.toUserId !== null) {
      submission.message.to = this.toUserId;
      submission.message.roomId = this.roomId;
      this._ioService
        .sendChatMessageWithFile(submission)
        .subscribe((res) => {});
    } else {
      submission.message.groupId = this.roomId;
      this._groupService
        .sendChatMessageWithFile(submission)
        .subscribe((res) => {});
    }
    setTimeout(() => {
      this.link.chatImageRefresher("image");
    }, 2000);
    $("#messageFileModal").modal("hide");
    $("#file-upload-messages").val("");
    setTimeout(() => {
      $(".Firefox .Rooms").scrollTop(99999);
    }, 1000);
  }
  triggerImageUpload(chatImageUpload, type) {
    this.selectedFileType = type;
    this.isButtonEnabled = false;
    $("#file-upload-messages").val("");
    $(chatImageUpload).trigger("click");
  }
  revert() {
    $(".msgList").addClass("current");
    $(".msgContent").removeClass("current");
    $("#messages_header").removeClass("current");
    $(".Rooms").hide();
  }
}
